import * as ActionTypes from "../constants/ActionTypes";
import {TOGGLE_SELECTION_TRIGGERED} from "../constants/ActionTypes";
import {delve} from "../util/util";

// **************************************************************************************************************
export const productSelectionReducer = (state = {
    selectedArticle: false,
    activatedArticle: false,
    baseArticleDataLoaded: false,
    currentProduct: false,
    selectedAccount: false,
    ipChanges: false
}, action) => {

    let newState;

    switch (action.type) {

        case TOGGLE_SELECTION_TRIGGERED:
            if (action && action.selectedContentId === "OUTSOURCING_ADDPROJECT") {
                return Object.assign({}, state, {baseArticleDataLoaded: false});
            } else {
                return state;
            }

        case ActionTypes.PRODUCT_SET_CURRENT:

            newState = Object.assign({}, state)
            newState.currentProduct = action.articleNumber
            newState.selectedAccount = action.selectedAccount

            return newState


        case ActionTypes.BASE_ARTICLE_SELECT:

            newState = Object.assign({}, state)
            newState.selectedArticle = action.articleNumber

            return newState


        case ActionTypes.BASE_ARTICLE_DESELECT:

            newState = Object.assign({}, state)
            newState.selectedArticle = false
            newState.activatedArticle = false

            return newState


        case ActionTypes.BASE_ARTICLE_REQUEST:

            return Object.assign({}, state, {baseArticleDataLoaded: false})


        case ActionTypes.BASE_ARTICLE_SUCCESS:

            return Object.assign({}, state, {baseArticleDataLoaded: true, activatedArticle: action.payload.articleId})

        case ActionTypes.BASE_ARTICLE_CUSTOM_SELECTED:

            return Object.assign({}, state, {baseArticleDataLoaded: true})


        case ActionTypes.STEP_SELECTED:
            // reset when step changes
            return Object.assign({}, state, {ipChanges:false})


        case ActionTypes.PRE_UPGRADECHECK_SUCCESS:
            return Object.assign({}, state, {ipChanges:delve(action, 'response.result.ipChanges')})


        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/ProductSelection.js
 **/